import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';

type PaymentDeleteFormProps = {
  click: () => void;
};

export default function PaymentDeleteForm({ click }: PaymentDeleteFormProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 pt-2">{t('payments.deletecardtitle')}</h1>
      <p className="pt-1 instructions">{t('payments.deletecardinfo')}</p>

      <div className="pt-3 ion-text-center">
        <IonButton
          fill="outline"
          color="danger"
          onClick={() => click()}
          className="btn-default btn-inverted btn-warn btn-wide-80"
        >
          <IonIcon slot="start" src={'assets/icon/trash.svg'}></IonIcon>
          {t('payments.deletecard')}
        </IonButton>
      </div>
    </>
  );
}
